import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";
import AccountService from "../../Services/AccountService";
import { useAuth } from "../../Utils/Auth";
import { useFormik } from "formik";
import { LoginSchema } from "../../Services/schema";
import { toTitleCase } from "../../Utils/helper";

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [authForm] = useState({ userName: "", password: "" });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: authForm,
    validationSchema: LoginSchema,
    onSubmit: async (values, action) => {
      console.log("values++===============>", values);
      await authFormHandler(values);
      resetForm();
    },
    enableReinitialize: true,
  });

  const authFormHandler = async (values) => {
    await AccountService.adminlogin(values) // Corrected here to pass values directly
      .then((res) => {
        if (res.status === 200) {
          sessionStorage.setItem("user", res.data.data.accessToken);
          sessionStorage.setItem("role", res.data.data.roles);
          console.log("admin");
          toast.success("Login Successfully");
          auth.login();
          navigate("/welcome");
          window.location.reload();
        } else {
          toast.error(res.data.data.message);
          navigate("/");
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error("Invalid User Id Or Password");
          return;
        }
      });
  };

  return (
    <div>
      <section
        className="vh-100"
        style={{
          backgroundImage:
            "radial-gradient(circle,rgba(255, 255, 255, 0.8) 0%, rgba(148, 187, 233, 1) 100%)",
        }}
      >
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <div className="col-12 col-md-8 col-lg-5">
            <div className="card border-0 p-4 shadow-sm rounded-3">
              <div className="text-center mb-4">
                <div className="d-inline-block p-3 rounded-circle mb-3" style={{ backgroundColor: '#e6f0fa' }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="#4682b4">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
                  </svg>
                </div>
                <h3 className="fw-bold mb-1" style={{ color: '#4682b4' }}>HOBHIASB</h3>
                <p className="text-muted">Admin Dashboard</p>
              </div>

              <form >
                <div className="mb-3">
                  <label className="form-label text-secondary">Username</label>
                  <input
                    type="text"
                    name="userName"
                    className={`form-control ${errors.userName && touched.userName ? 'is-invalid' : ''}`}
                    placeholder="Enter Username"
                    value={values.userName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.userName && touched.userName && (
                    <div className="invalid-feedback">{toTitleCase(errors.userName)}</div>
                  )}
                </div>

                <div className="mb-4">
                  <label className="form-label text-secondary">Password</label>
                  <input
                    type="password"
                    name="password"
                    className={`form-control ${errors.password && touched.password ? 'is-invalid' : ''}`}
                    placeholder="Enter Password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && touched.password && (
                    <div className="invalid-feedback">{toTitleCase(errors.password)}</div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn w-100  fw-medium"
                  style={{
                    backgroundColor: '#4682b4',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px'
                  }}
                  onClick={handleSubmit}
                >
                  Sign In
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
